/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
	/**
	 * Checkbox tree for permission selecting
	 */
	let permissionTree = $('.permission-tree :checkbox');

	permissionTree.on('click change', function () {
		if ($(this).is(':checked')) {
			$(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
		} else {
			$(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
		}
	});

	permissionTree.each(function () {
		if ($(this).is(':checked')) {
			$(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
		}
	});

	/**
	 * Disable submit inputs in the given form
	 *
	 * @param form
	 */
	function disableSubmitButtons(form) {
		const alwaysEnabled = form.data('enabled') !== undefined ? form.data('enabled') : false;

		if(!alwaysEnabled) {
			form.find('input[type="submit"]').attr('disabled', true);
			form.find('button[type="submit"]').attr('disabled', true);
		}
	}

	/**
	 * Enable the submit inputs in a given form
	 *
	 * @param form
	 */
	function enableSubmitButtons(form) {
		form.find('input[type="submit"]').removeAttr('disabled');
		form.find('button[type="submit"]').removeAttr('disabled');
	}

	/**
	 * Disable all submit buttons once clicked
	 */
	$('form').submit(function () {
		disableSubmitButtons($(this));
		return true;
	});

	$('document').ready(function(){
		var cobrowsing = CobrowsingClient({
			host: 'wss://ws-service.webwithme.com',
			tokenHost: '/api/auth/webwithme',
			improvedSecurity: true,
			menu_phone_number_text: 'Amennyiben az oldalunk használatához szeretne segítséget kérni,</br>először hívja ügyfélszolgálatunkat az 1 585 8888 telefonszámon!</br>Ez a nyomógomb a telefonos segítség kiegészítésére szolgál.',
			menu_customer_support_label: false,
			send_element_focus: true,
			opening_hours_enable: true,
			opening_hours_data: {'mon':['08:00','17:00'],'tue':['08:00','20:00'],'wed':['08:00','17:00'],'thu':['08:00','17:00'],'fri':['08:00','16:00'],'sat':'closed','sun':'closed'}
		});
		cobrowsing.loadStartButton();
	});

	/**
	 * Add a confirmation to a delete button/form
	 */
	$('body')
		.on('submit', 'form[name=delete-item]', function (e) {
			e.preventDefault();

			Swal.fire({
				title: 'Biztos törlöd ezt az elemet?',
				showCancelButton: true,
				confirmButtonText: 'Törlés',
				cancelButtonText: 'Mégsem',
				icon: 'warning',
			}).then(result => {
				if (result.value) {
					this.submit();
				} else {
					enableSubmitButtons($(this));
				}
			});
		})

		.on('submit', 'form[name=confirm-item]', function (e) {
			e.preventDefault();

			Swal.fire({
				title: 'Biztos ezt akarod csinálni?',
				showCancelButton: true,
				confirmButtonText: 'Folytatás',
				cancelButtonText: 'Mégsem',
				icon: 'warning',
			}).then(result => {
				if (result.value) {
					this.submit();
				} else {
					enableSubmitButtons($(this));
				}
			});
		})
		.on('click', 'a[name=confirm-item]', function (e) {
			/**
			 * Add an 'are you sure' pop-up to any button/link
			 */
			e.preventDefault();

			Swal.fire({
				title: 'Biztos ezt akarod csinálni?',
				showCancelButton: true,
				confirmButtonText: 'Folytatás',
				cancelButtonText: 'Mégsem',
				icon: 'info',
			}).then(result => {
				result.value && window.location.assign($(this).attr('href'));
			});
		});

	// Remember tab on page load
	$('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
		let hash = $(e.target).attr('href');
		history.pushState ? history.pushState(null, null, hash) : (location.hash = hash);
	});

	let hash = window.location.hash;
	if (hash) {
		$('.nav-link[href="' + hash + '"]').tab('show');
	}

	// Enable tooltips everywhere
	$('[data-toggle="tooltip"]').tooltip();
});
